<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Complaint Report" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12 project-list filter-sort">
								<div class="row">

									<div class="col-md-2">
										<label class="control-label">From Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @change="fetchReport()">
									</div>
									<div class="col-md-2">
										<label class="control-label">To Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string @change="fetchReport()">
									</div>
									
									<div class="col-md-2">
										<label class="control-label">Staff</label>
										<select class="form-select" v-model="staff_id" @change="fetchReport()">
											<option value="">All Staffs</option>
											<option :value="staff.id" v-for="staff in staffs" :key="staff.id">
											{{staff.name}}
											</option>
										</select>
									</div>

									<div class="col-md-2">
										<label class="control-label">Type</label>
										<select class="form-select" v-model="type" @change="fetchReport()">
											<option value="">All Types</option>
											<option value="2">Repair</option>
											<option value="1">SIM Change</option>
											<option value="3">Replacement</option>
										</select>
									</div>
									
									<div class="col-md-2" style="margin-top: 34px;">
										<!-- <div class="btn btn-info" v-if="Boolean(accessories.length)" @click="generatePDF()">Pdf</div> -->
										<div class="btn btn-info" @click="generatePDF()">Download</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-body">

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
											<th>IMEI</th>
											<th>Vehicle No.</th>
											<th>Date</th>
											<th>Type</th>
											<th>Staff</th>
											<th>Remarks</th>
											<th>Total Amount</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(complaints.length)">
                                        <tr align="center" v-for="(complaint,index) in complaints" :key="complaint.id">
                                            <td>{{index + 1}}</td>
											<td>{{complaint.imei}}</td>
											<td>{{complaint.vehicle_no}}</td>
											<td>{{$filters.formatDate(complaint.created_date)}}</td>
											<td>{{complaint.service_type == 1 ? 'SIM Change' : complaint.service_type == 2 ? 'Repair' : complaint.service_type == 3 ? 'Replacement' : 'N/A' }}</td>
											<td>{{complaint.staff_name}}</td>
											<td>{{complaint.remarks}}</td>
											<td>Rs. {{ complaint.total_amount ?? 0 }}</td>
                                        </tr>
                                       
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="8" class="text-center">No data</td>
										</tr>
									</tbody> 
								</table>
							</div>

							<!--- pagination starts --->
							<caption v-if="Boolean(complaints.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchReport(page.url + '&from_date=' + start_date + '&to_date=' + end_date +  '&limit=' + listing_length +  '&staff_id=' + staff_id +  '&type=' + type)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!--- pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

   	</div>
</template>


<script>

	export default {
		name: "Work Report",
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				complaints: [],
				staffs: {},
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,		

				staff_id: "",
				type:"",		
			};
		},
		mounted() {},

		created() {
			this.fetchReport();
			this.fetchStaffs();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchStaffs(page_url = null) {
                let url = "/staffs/staffsList"; 
                page_url = page_url || url;

                this.getToken();
                this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.staffs = responseData;
                                                    
                })
                .catch((err) => console.log(err));
            },

			fetchReport(page_url = null) {
				this.getToken();
				let url = "/staffs/workReport?limit=" + this.listing_length + "&from_date=" + this.start_date + "&to_date=" + this.end_date + "&type=" + this.type + "&staff_id=" + this.staff_id;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.complaints = responseData.data;
						console.log(responseData);
						this.pagination = responseData.links;
						this.from = responseData.from;
						this.to = responseData.to;
						this.total = responseData.total;
					})
					.catch((err) => console.log(err));
			},

			generatePDF() 
			{
				this.getToken();
				let page_url = "/staffs/workReportDownload?material_id=" + this.material_id  + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Work_report" + this.start_date + "_" + this.end_date + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();
					this.pdf.loading = false;
						
				})
				.catch((err) => console.log(err));
			},


		},
	};
</script>
